import { Outlet } from 'react-router-dom';

import EntitiesHeader from '@/components/campaigns/EntitiesHeader/EntitiesHeader';
import { Main } from '@/components/common/Main';
import { Modals } from '@/router';
import { useGlobalStore } from '@/store/global';
import { getSessionByKeys } from '@/store/global/session/selectors';
import { createStore, getPersistedCampaignsFiltersForUser, Provider } from '@/store/local/campaigns';

export default function Campaigns() {
  const { user: userId = '' } = useGlobalStore(store => getSessionByKeys(store, ['user']));

  return (
    <Provider createStore={() => createStore(getPersistedCampaignsFiltersForUser(userId), userId)}>
      <EntitiesHeader />
      <Main className="mainLayout mainLayout__campaigns">
        <Outlet />
      </Main>
      <Modals id="advertiser-modal" />
      <Modals id="campaignPlan-modal" />
      <Modals id="campaignPlanSettings-modal" />
      <Modals id="insertionOrder-modal" />
      <Modals id="lineItem-modal" />
      <Modals id="commonPrompt-modal" />
      <Modals id="adsValidation" />
    </Provider>
  );
}
